/**
 * @namespace StringHelper 
 */
const StringHelper = {
    /**
     * Kebabize camel case string (for ex. strCamel -> str-camel )
     * @param {string } str Camel case string
     * @returns {string} Kebab case case string
     */
    camelCaseToKebabCase: str => {
        return str?.split('').map((letter, idx) => {
            return letter.toUpperCase() === letter && isNaN(letter) && letter !== '-'
                ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                : letter;
        }).join('');
    },
    /**
     * Convert string to camel case string
     * @param {string } str Input string
     * @returns {string} Camel cased string
     */
    toCamelCase: str => {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) return "";
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    },
    /**
     * Strip HTML content
     * @param {string } str Input string
     * @returns {string}  Stripped HTML content
     */
    stripHtml(str, removeContentOfTags = ['title', 'style', 'script'], removeEntities = true) {
        if (typeof str !== 'string') return '';
        let tagsRegExp = Array.isArray(removeContentOfTags) && removeContentOfTags.length ? removeContentOfTags.reduce((a, b, i) => {
            return i === 1 ? `(<${a}.*>[\\w\\W]*?<\/${a}>)|(<${b}.*>[\\w\\W]*?<\/${b}>)|` : `${a}(<${b}.*>[\\w\\W]*?<\/${b}>)|`
        }) : '';
        let entityRegExp = removeEntities ? `|(&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});)` : '';
        let regularExpression = new RegExp(`${tagsRegExp}(<!--.*?-->)|(<!--[\\S\\s]+?-->)|(<!--[\\S\\s]*?$)|((<([^>]+)>)|(\\r\\n|\\n|\\r))${entityRegExp}`, 'gm');
        return str.replace(regularExpression, '').replace(/\s\s+/g, ' ').trim();
    },
    /**
     * The FNV-1a hash function is simple and fast, suitable for non-cryptographic applications like hash tables or checksums. 
     * It generally produces fewer collisions than simpler hash functions like CRC32, but it's still not cryptographically secure.
     * @param {string} str 
     * @returns {Number}
     */
    fnv1a(str) {
        const FNV_prime = 16777619;
        const offset_basis = 2166136261;
        let hash = offset_basis;

        for (let i = 0; i < str.length; i++) {
            hash ^= str.charCodeAt(i);
            hash *= FNV_prime;
        }

        return hash >>> 0; // Unsigned 32-bit integer
    }

}
export default StringHelper;